import BigNumber from 'bignumber.js';

export interface EwalletInfo {
	studentFirstName: string;
	studentLastName: string;
	grade: string;
	teacherFirstName: string;
	teacherLastName: string;
	amount: BigNumber;
	id: number;
	ownersEmail?: string;
}

export const defaultEwalletInfo: EwalletInfo = {
	studentFirstName: '',
	studentLastName: '',
	grade: '',
	teacherFirstName: '',
	teacherLastName: '',
	amount: BigNumber(0),
	id: 0,
	ownersEmail: '',
};
